import styled from 'styled-components'
import { colors } from 'styles'

const StyledLogout = styled.div`
  @keyframes top-down {
    0% {
      top: -100vh;
    }
    100% {
      top: 0;
    }
  }
  @keyframes left-right {
    0% {
      left: -100vw;
    }
    100% {
      left: 0;
    }
  }
  @keyframes right-left {
    0% {
      right: -100vw;
    }
    100% {
      right: 0;
    }
  }
  .logoutContainer {
    display: flex;
    min-height: 95vh;
    align-content: center;
    flex-flow: row wrap;
    background-image: url(${() =>
        require(`assets/logout/logout-cover${window.devicePixelRatio >= 2 ? '@2x' : ''}.png`)}),
      radial-gradient(ellipse at center, #ffffff 20%, #e0e0e0 100%);
    background-size: contain;
    background-position: top;
    background-repeat: no-repeat;
    & * {
      box-sizing: border-box;
    }
  }
  .logoutStatus {
    position: relative;
    width: 100%;
    padding: 2rem 1.5rem;
    background: #ffffff;
    text-align: center;
    animation: top-down 1s ease 1;
    svg {
      vertical-align: middle;
    }
  }
  .redirMsg {
    position: relative;
    width: 50%;
    padding: 1rem;
    background: #202124;
    color: ${colors.mainInverted};
    text-align: right;
    font-size: 1.8rem;
    line-height: 3.6rem;
    font-weight: bold;
    animation: left-right 1s ease 1;
  }
  .redirCountdown {
    display: flex;
    position: relative;
    width: 50%;
    align-content: center;
    align-items: center;
    text-indent: 1rem;
    color: ${colors.mainInverted};
    background: ${colors.main};
    font-size: 2.8rem;
    font-weight: bold;
    transition: 0.3s ease;
    animation: right-left 1s ease 1;
  }
`

export default StyledLogout
